import React, { Component } from "react";
import {observer, inject} from 'mobx-react';

const hallListPanelWrapper = {
    "height":"100%",
    "width":"100%",
};

@inject('RootStore')
@observer
export default class HallListPanel extends Component {
    render() {
        return (
          <div style={hallListPanelWrapper}>
              <img src={this.props.RootStore.configStore.promo} alt="" height="100%" width="100%"/>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_panel/hall_panel_promo_only.jsx